import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import { Typography } from '../../../../designSystem/components/Typography'

export const MetricsSummary = ({
  icon,
  iconColor,
  title,
  value,
}) => (
  <div className={`
  bg-white rounded-xl p-4 flex items-center gap-4 shadow-md border border-gray-100
  `}>
    <FontAwesomeIcon
      icon={icon}
      className={`text-3xl ${iconColor} w-[50px]`}
    />
    <div>
      <Typography variant="body">
        {title}
      </Typography>
      <Typography variant="hero">
        {value}
      </Typography>
    </div>
  </div>
)
